import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import classNames from "classnames";
import "./style.scss";
import useQuery from "../../utils/useQuery";
import api from "../../utils/api";

class DataPrivacyPolicy extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      consentName: null,
      consentContent: null,
      hasError: false,
      errorMessage: null
    };
  }
  componentDidMount() {
    const { fields } = this.props;
    const { defaultErrorText } = fields;
    const query = useQuery();
    const { itemId } = query;
    if (itemId) {
      api
        .dpp({
          itemId
        })
        .then(res => {
          this.setState({
            consentName: res.consentName,
            consentContent: res.consentContent
          });
        })
        .catch(res => {
          this.setState({
            hasError: true,
            errorMessage: defaultErrorText.value
          });
        });
    } else {
      this.setState({
        hasError: true,
        errorMessage: defaultErrorText.value
      });
    }
  }

  render() {
    const containerClasses = classNames("data-privacy-policy grid full-width");
    const headerClasses = classNames("privacy-policy-header");
    const bodyClasses = classNames("privacy-policy-body");
    return (
      <div className={containerClasses}>
        <h1 className={headerClasses}>{this.state.consentName}</h1>
        <RichText tag={"div"} className={bodyClasses} field={{ value: this.state.consentContent }} />

        {this.state.hasError && <div className="error-message">{this.state.errorMessage}</div>}
      </div>
    );
  }
}

export default DataPrivacyPolicy;
